import { InputIME } from "@/components/input-ime";
import { useActiveWatchlist } from "@/features/watchlist/services/get-active-watchlist";
import { useLang } from "@/hooks/use-lang";

type WatchlistNameEditInputProps = {
  setIsEditing: (value: boolean) => void;
  submitRename: ({ newName }: { newName: string }) => void;
};

export const WatchlistNameEditInput = ({
  setIsEditing,
  submitRename,
}: WatchlistNameEditInputProps) => {
  const { t } = useLang();
  const { data: activeWatchlist } = useActiveWatchlist();

  const watchlistName =
    activeWatchlist?.watchlistName ?? t.layout.watchlist.defaultWatchlistName;

  return (
    <InputIME
      aria-label="change watchlist name"
      defaultValue={watchlistName}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === "Escape") {
          setIsEditing(false);
          if (e.currentTarget.value && e.currentTarget.value !== watchlistName)
            submitRename({ newName: e.currentTarget.value });
        }
      }}
      autoFocus
      maxLength={20}
      onBlur={(e) => {
        setIsEditing(false);
        if (e.currentTarget.value && e.currentTarget.value !== watchlistName)
          submitRename({ newName: e.currentTarget.value });
      }}
      onClick={(e) => e.stopPropagation()}
      className="ml-2"
    />
  );
};
